import { useEffect } from 'react';

import { useHistory } from 'react-router-dom';

import { parseOauthState } from '../../utils/oauthState';
import { getUrlParams } from '../../utils/url';

export interface AuthHandlerProps {}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const AuthHandler = (props: AuthHandlerProps) => {
    const history = useHistory();

    useEffect(() => {
        const state = parseOauthState();
        const { token, error } = getUrlParams();

        if (error) {
            return history.push(`/login?error=${error}`);
        }

        if (!state) {
            return history.push('/login');
        }

        const { user_uuid: userUuid, redirect, redirect_absolute: redirectAbsolute } = state;

        // Legacy auth provides user_uuid in oauth state
        if (userUuid) {
            localStorage.setItem('user_uuid', userUuid);
            localStorage.setItem('user_uuid_time', String(new Date().getTime()));
        }

        if (token) {
            localStorage.setItem('user_uuid', token);
            localStorage.setItem('user_uuid_time', String(new Date().getTime()));
        }

        if (redirect && redirect.includes('.html')) {
            // legacy redirect (probably needs "state"?)

            // eslint-disable-next-line @typescript-eslint/naming-convention
            const { user_uuid, ...newState } = state;
            const params = new URLSearchParams({ state: JSON.stringify(newState) });

            if (redirect.includes('?')) {
                window.location.replace(`${redirect}&${params}`);
            } else {
                window.location.replace(`${redirect}?${params}`);
            }

            return;
        }

        if (redirect && redirectAbsolute) {
            window.location.replace(redirect);
            return;
        }

        if (redirect) {
            // React redirects
            history.push(redirect);
        }
    }, [history]);

    return <></>;
};

export default AuthHandler;
